import { IMAGE_DISCLAIMER } from "@/constants/content";

export const ImageDisclaimer = ({ className = "", light = false }) => (
  <p className={`cp-image-disclaimer ${light ? "cp-image-disclaimer--light" : ""} ${className}`.trim()}>
    {IMAGE_DISCLAIMER}
  </p>
);
